import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import Utils from "../../utils";
import BarraTitulo from "../Generico/BarraTitulo";
import ForList from "../Skeleton/ForList";

const Delivery = () => {
  const [taxaInput, setTaxaInput] = useState({ kmFinal: 0, valor: 0 });
  const [taxas, setTaxas] = useState([]);
  const [open, setOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [skeleton, setSkeleton] = useState(false);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { enqueueSnackbar } = useSnackbar();
  const service = new AuthService();

  const novaTaxa = () => {
    setTaxaInput({ kmFinal: 0, valor: 0 });
  };

  useEffect(() => {
    setSkeleton(true);
    service
      .get("/configuracaoTaxa/list")
      .then((resp) => {
        setSkeleton(false);
        setTaxas(resp);
      })
      .catch(() => {
        enqueueSnackbar("Erro ao salvar a taxa de entrega.", {
          variant: "error",
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setTaxaInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveAll = () => {
    service
      .post("/configuracaoTaxa", taxaInput)
      .then((resp) => {
        const updatedTaxas = taxas.filter((taxa) => taxa.id !== taxaInput.id);
        updatedTaxas.push(resp);
        setTaxas(updatedTaxas);
        setOpen(false);
        enqueueSnackbar("Taxas salvas com sucesso.", { variant: "success" });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleClickOpenNew = () => {
    setOpen(true);
    novaTaxa();
  };

  const handleClickOpenEdit = (taxa) => {
    setOpen(true);
    setTaxaInput({ ...taxa });
  };

  const handleDelete = (taxa, index) => {
    service
      .delete(`/configuracaoTaxa/${taxa.id}`)
      .then(() => {
        setTaxas((prevTaxas) => {
          const updatedTaxas = [...prevTaxas];
          updatedTaxas.splice(index, 1);
          return updatedTaxas;
        });
        setPage(0);
        enqueueSnackbar("Taxa excluída com sucesso", { variant: "success" });
      })
      .catch(() => {
        enqueueSnackbar("Não foi possível excluir a taxa de entrega.", {
          variant: "error",
        });
      });
  };

  const validaTaxas = () => {
    const taxaExistente = taxas.find(
      (taxa) => taxa.kmFinal === taxaInput.kmFinal && taxaInput.id !== taxa.id
    );
    if (taxaExistente) {
      enqueueSnackbar("Taxa já cadastrada.", { variant: "error" });
    } else {
      handleSaveAll();
    }
  };

  const handleChangePage = (__, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection={isTablet ? "column" : "row"}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box sx={{ width: "100%" }}>
          <BarraTitulo
            title="Taxas por quilometragem"
            subTitle="Configure as taxas de entrega conforme a distância"
          />
        </Box>

        <Box
          sx={{
            width: isTablet ? "100%" : "auto",
            minWidth: "10rem",
            marginBottom: "0.75rem",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            fullWidth
            startIcon={<AddIcon />}
            size="medium"
            onClick={handleClickOpenNew}
          >
            Nova taxa
          </Button>
        </Box>
      </Box>
      <Paper sx={{ padding: "1rem" }}>
        <Box sx={{ margin: " 0.5rem" }}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Distância</TableCell>
                  <TableCell align="right">Valor da taxa</TableCell>
                  <TableCell align="right" />
                </TableRow>
              </TableHead>

              {skeleton ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={3}>
                      <ForList rows={rowsPerPage} height={50} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : null}

              <TableBody>
                {taxas
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((taxa, index) => (
                    <TableRow key={taxa.id}>
                      <TableCell align="left">Até {taxa.kmFinal} km</TableCell>
                      <TableCell align="right">
                        {Utils.formatNumber(taxa.valor)}
                      </TableCell>
                      <TableCell scope="medium" align="right">
                        <Button
                          onClick={() => handleClickOpenEdit(taxa)}
                          startIcon={<EditIcon />}
                        >
                          Editar
                        </Button>
                        <IconButton
                          onClick={() => handleDelete(taxa, index)}
                          size="large"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={taxas.length}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage="Linhas por página"
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Box>
        <Dialog open={open} onClose={handleClose} fullWidth>
          <DialogTitle>Taxa de entrega</DialogTitle>
          <DialogContent>
            <Box p={2}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TextField
                    onChange={handleChange}
                    value={taxaInput.kmFinal || ""}
                    variant="outlined"
                    label="Até a distância (em km)"
                    name="kmFinal"
                    fullWidth
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TextField
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    onChange={handleChange}
                    value={taxaInput.valor || ""}
                    label="Cobrar o valor da taxa"
                    variant="outlined"
                    name="valor"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="text"
              onClick={handleClose}
              startIcon={<CancelIcon />}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={validaTaxas}
              startIcon={<SaveIcon />}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </>
  );
};

export default Delivery;
